import styled from "styled-components";

const Container = styled.footer`
    font-style: italic;
    color: #ccc;
    text-align: center;
`

const Disclaimer = () => {
    return (
        <Container>
            By using this site you agree you are over 18 years old. This site is for entertainment purposes only. No data is transmitted upon submission.
        </Container>
    )
}

export default Disclaimer;